export function deepMerge<T>(base: T, patch: any): T {
  if (patch === null || patch === undefined) return base;
  if (Array.isArray(base) || Array.isArray(patch)) return patch as T;
  if (typeof base !== "object" || typeof patch !== "object") return patch as T;

  const out: any = { ...(base as any) };
  for (const k of Object.keys(patch)) out[k] = deepMerge(out[k], patch[k]);
  return out as T;
}
